import { Ability } from '@casl/ability';
import { initialAbility } from './initialAbility';

//  Read ability from localStorage
// * Handles auto fetching previous abilities if already logged in user
// ? You can update this if you store user abilities to more secure place
// ! Anyone can update localStorage so be careful and please update this
const userDataString = localStorage.getItem('userData');
let userData = null;
let existingAbility = null;

try {
  if (userDataString) {
    userData = JSON.parse(userDataString);
    existingAbility = userData ? userData.ability : null;
  }
} catch (error) {
  console.error('Error parsing userData from localStorage:', error);
  // Clear corrupted data
  localStorage.removeItem('userData');
}

export default new Ability(existingAbility || initialAbility);
